import React from 'react';
import styles from './styles.module.css';

type DisclaimerInfoProps = {
  text: string;
};

export const DisclaimerInfo = ({ text }: DisclaimerInfoProps) => {
  return (
    <section className={styles.disclaimerSection}>
      <span className={styles.disclaimerText}>{text}</span>
    </section>
  );
};
